<!-- #18 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Package
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card class="mt-2">
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Upload

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="d-flex">
        <v-col md="6">
          <v-form>
            <ul class="text-left mb-2">
              <li>Order Reference No has to be unique</li>
              <li>
                Consignment currency has to destination country local currency
              </li>
              <li>
                Total Weight has to be greater than or equal to total weight of
                all package within 1 order
              </li>
              <li>
                Package weight has to greater than or equal to commodity weight
              </li>
              <li>
                Address Line1 and Address Line 2 should not be greater the 150
                character for both consignee and consignor
              </li>
              <li>
                Building name and Street address should not be greater the 20
                character for both consignee and consignor
              </li>
            </ul>
          </v-form>
        </v-col>
        <v-col md="6" v-if="items.length">
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1 mr-4"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.service_name`]="{ item }">
              <div
                :style="{
                  maxWidth: '150px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }"
              >
                {{ item.service_name }}
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    :style="{ backgroundColor: 'green', color: 'white' }"
                    v-bind="attrs"
                    v-on="on"
                    @click="activate(item)"
                  >
                    {{ item.status == 1 ? "Activated" : "Not Activated" }}
                  </v-chip>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(country, index) in countries"
                    :key="index"
                  >
                    <v-list-item-title>{{ country }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-col>
      </v-card-text>

      <v-divider class="mb-3"></v-divider>
      <span style="color: green" class="pl-3">
        We have added new feature to upload service type for each orders.
        Service Type is mandatory in Order upload.
      </span>
      <v-card-text>
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row no-gutters>
              <v-col md="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start Typing to Search"
                  class="pt-0 text-center required"
                  :rules="[
                    (v) =>
                      (v != null && v.hasOwnProperty('id')) ||
                      'Please Select Client',
                  ]"
                  return-object
                  @focus="fetchClientList"
                  @input="fetchHandling"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="delivery_type"
                  :items="deliveryTypes"
                  item-text="text"
                  item-value="value"
                  label="Delivery Type"
                  class="pt-0 pl-4 text-center required"
                  placeholder="Start Typing to Search"
                  :rules="[(v) => !!v || 'Please Select Delivery Type']"
                  @input="fetchHandlingclient"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col md="3" v-if="delivery_type == 'crossborder'">
                <v-autocomplete
                  v-model="handling"
                  :items="handlings"
                  item-text="text"
                  item-value="value"
                  label="Duty Handling"
                  placeholder="Start Typing to Search"
                  class="pt-0 pl-4 text-center required"
                  :rules="[(v) => !!v || 'Duty Handling is required']"
                  v-if="handlings.length > 1"
                  outlined
                  dense
                ></v-autocomplete>
                <v-text-field
                  v-else
                  v-model="handling"
                  label="Duty Handling"
                  class="required pl-4 pt-0"
                  :rules="[(v) => !!v || 'Duty Handling is required']"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="3" class="custom pb-0">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  label="Select your Packages File"
                  class="required pl-4"
                  outlined
                  dense
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  :rules="[(v) => !!v || 'Please Select Packages File']"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <p
              v-if="nopermission"
              class="pb-0"
              style="font-size: 14px; text-align: left; color: orange"
            >
              Duty Handling Is Not Available For Client.
            </p>

            <v-row class="text-left pt-0 mt-0 mb-0 pb-0">
              <v-col class="text-left pt-0 mt-0 mb-0 pb-0">
                <v-btn
                  color="green"
                  dark
                  class="mr-3"
                  @click="listPage"
                  v-if="checkPermission('app_ecom_vendors:excel_details')"
                >
                  Uploaded List
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                  :class="$store.getters.user.user_category == 1 ? 'ml-3' : ''"
                  v-if="
                    checkPermission(
                      'app_consignment_order:package_details_upload'
                    )
                  "
                >
                  Upload
                </v-btn>
                <v-btn
                  color="info"
                  class="ml-3"
                  :loading="downloader"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>

    <Explain />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/plugins/event-bus";
import Explain from "@/components/front/packages/Template";

export default {
  components: {
    Explain,
  },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchClientList();
    });
  },
  data() {
    return {
      items: [],
      page: "listPage",
      packages: [],
      clients: [],
      selectedClient: {},
      total: 0,
      packagesLoader: false,
      search: null,
      options: {},
      searchType: null,
      file: null,
      fileLoader: false,
      dialog: false,
      statusType: null,
      downloader: false,
      uploadRes: {},
      uploadResDialog: false,
      clientLoader: false,
      handlings: [],
      handling: [],
      nopermission: false,
      countries: [],
      deliveryTypes: [
        { text: "Cross Border", value: "crossborder" },
        { text: "Domestic", value: "domestic" },
      ],
      delivery_type: null,
      findHandling: null,
      headers: [
        {
          text: "Service Code",
          value: "service_code",
          sortable: false,
          width: 150,
        },
        {
          text: "Service Name",
          value: "service_name",
          sortable: false,
          width: "250px",
        },

        { text: "Status", value: "status", sortable: false },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchPackage();
      },
      deep: true,
    },
    search() {
      this.fetchPackage();
    },
    searchType() {
      if (this.search) this.fetchPackage();
    },
  },

  created() {
    EventBus.$off("packageStatus");
    EventBus.$on("packageStatus", (status) => {
      this.statusType = status;
      this.fetchPackage();
    });
  },

  methods: {
    ...mapActions([
      "getAllPackages",
      "downloadPackageDetails",
      "downloadPackageDataTemplate",
      "uploadPackageExcel",
      "fetchClient",
      "snackBar",
      "getclientconfig",
    ]),
    activate(item) {
      this.countries = item.country;
    },
    listPage() {
      this.$router.push({
        name: "packageStatusList",
        params: {
          type: "package_upload",
        },
      });
    },
    fetchHandlingclient() {
      this.file = null;
      if (this.$store.getters.user.user_category == 1) {
        this.selectedClient.id = this.$store.getters.user.id;
        this.fetchHandling();
      }
    },
    fetchHandling() {
      if (this.selectedClient) {
        this.handlings = [];
        this.handling = "";

        this.getclientconfig(this.selectedClient.id).then((res) => {
          this.findHandling = res.data.data.duty_handling;
          this.items = res.data.data.rsa_service.filter(
            (item) => item.status == 1
          );
          if (
            this.findHandling == "ddu,ddp" ||
            this.findHandling == "ddp,ddu"
          ) {
            this.handlings = [
              { text: "DDU", value: "ddu" },
              { text: "DDP", value: "ddp" },
            ];
            this.nopermission = false;
          } else if (this.findHandling == "ddp") {
            this.handlings = { text: "DDP", value: "ddp" };
            this.handling = "DDP";
            this.nopermission = false;
          } else if (this.findHandling == "ddu") {
            this.handling = "DDU";
            this.handlings = { text: "DDU", value: "ddu" };
            this.nopermission = false;
          } else if (this.findHandling == null) {
            this.nopermission = true;
          }
        });
      }
    },
    fetchPackage() {
      this.packages = [];
      this.packagesLoader = true;
      this.getAllPackages({
        ...this.options,
        search: this.search,
        type: this.searchType,
        status: this.statusType,
      })
        .then((res) => {
          this.packagesLoader = false;
          this.packages = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },

    editItem(item) {
      this.$router.push({
        name: "PackageDetails",
        params: {
          id: item.tracking_no,
        },
      });
    },

    close() {
      this.selectedClient = null;
      this.file = null;
      this.$refs.form?.reset();
      this.items = [];
      this.dialog = false;
    },

    download(id) {
      this.packagesLoader = true;
      this.downloadPackageDetails(id)
        .then((res) => {
          this.fileDownload(res);
          this.packagesLoader = false;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },

    downloadTemplate() {
      this.downloader = true;
      this.downloadPackageDataTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      if (this.userCategory.user_category === 3) {
        payload.append("client_id", this.selectedClient.id);
      }
      if (this.delivery_type == "crossborder")
        payload.append("custom_values", this.handling.toLowerCase());

      payload.append("delivery_type", this.delivery_type);

      this.uploadPackageExcel(payload)
        .then((res) => {
          this.fileLoader = false;
          this.dialog = false;
          this.uploadRes = res.data;
          this.$refs.form?.reset();
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
        })
        .catch(() => {
          this.fileLoader = false;
          // this.$refs.form?.reset();
        });
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "clickdna",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    fetchTrackingDetails(item) {
      this.$router.push({
        name: "ClientTrackingDetails",
        params: {
          id: item.tracking_no,
          viewName: "orderList",
        },
      });
    },
  },
};
</script>
<style>
.file-padding {
  padding-right: 72px;
}
.custom .v-text-field {
  padding-top: 0;
}
</style>
